import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-settings-notifications',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './notifications.component.html',
})
export class SettingsNotificationsComponent {}
